export enum Connection {
  Offline = 'offline'
}
